import * as R from 'ramda'
import { Box, styled } from '@mui/material'
import { MentionMenuItem } from './mention-menu-item'
import { useMentionUsers } from './mention-menu.react-hook'
import { MentionMenuItemSkeleton } from './mention-menu-item-skeleton'
import { useOpenedRoomId } from '$logic/opened-room'

const Root = styled(Box)`
  width: 100%;
  max-height: 161px;
  overflow: hidden auto;
  border-top: 1px solid;
`

export function MentionMenu({
  query,
  imageCaptionMode,
}: {
  query: string
  imageCaptionMode?: boolean
}) {
  const roomId = useOpenedRoomId()
  const { users, loading } = useMentionUsers(roomId, query)

  return (
    <Root
      sx={{
        backgroundColor: imageCaptionMode ? '#000000CC' : 'white',
        borderColor: imageCaptionMode ? 'semiBlack' : '#0000001a',
      }}
    >
      {loading
        ? R.repeat(
            <MentionMenuItemSkeleton imageCaptionMode={imageCaptionMode} />,
            3,
          )
        : users.map(userId => (
            <MentionMenuItem
              userId={userId}
              imageCaptionMode={imageCaptionMode}
            />
          ))}
    </Root>
  )
}

MentionMenu.defaultProps = {
  imageCaptionMode: false,
}
